<!-- <div class="row font-13">
    <div class="col-sm-5 col-12 d-flex gap-1 text-center align-items-center">
        <div class="logo"> </div> <b>PCS Management Consultancy Pvt. Ltd.</b> <p class="d-none d-md-block m-0">- All rights reserved.</p>
    </div>
    <div class="col-12 d-flex align-items-center col-sm-7" style="color: red;">
        <marquee>
            <h5>For immediate assistance, please don't hesitate to reach out to our dedicated support team at 9918000241
            </h5>
        </marquee>
    </div>
</div> -->

<div class="row font-13 align-items-center">
  <div class="col-sm-6 col-12 d-flex flex-column flex-sm-row align-items-center text-center text-sm-start gap-1">
    <div class="logo mb-sm-0 mb-1"></div>
    <div class="ps-2">
      <b>PCS Management Consultancy Pvt. Ltd.</b><br>
      <small class="text-muted">All rights reserved.</small>
    </div>
  </div>

  <div class="col-sm-6 col-12" style="color: red;">
    <marquee>
      <h5 class="m-0">
        For immediate assistance, please don't hesitate to reach out to our dedicated support team at 9918000241
      </h5>
    </marquee>
  </div>
</div>
